import { useFeatureAccess } from "@/Hooks/useFeatureAccess";
import React from "react";
import { IFeatureAccessProps } from "./interface";

const ZFeatureAccess: React.FC<IFeatureAccessProps> = ({
	requiredPlan,
	requiredRole,
	permissions,
	children,
	skipPermissions = false
}) => {
	const shouldRender = useFeatureAccess(
		requiredPlan,
		requiredRole,
		permissions,
		skipPermissions
	);

	return shouldRender ? <>{children}</> : null;
};

export default ZFeatureAccess;
